import {
  CytMobileFirstRedesignData,
  CytMobileFirstRedesignTestResult,
  CytMobileFirstRedesignVariant,
  UseCytMobileFirstRedesign,
} from "./types";
import { useMonarchRule } from "../MonarchRulesProvider";

const CUSTOM_RULE_ID = "cytMobileFirstRedesign";

const useCytMobileFirstRedesign: UseCytMobileFirstRedesign = () => {
  const { isLoading, value } = useMonarchRule<{
    data: CytMobileFirstRedesignData;
  }>(CUSTOM_RULE_ID);

  if (isLoading || !value) {
    return {
      isLoading,
      variant: "control",
    } as CytMobileFirstRedesignTestResult;
  }
  const variant: CytMobileFirstRedesignVariant =
    value.data?.isEnabled === true ? "test" : "control";

  const programCard = value.data?.programCard;

  const data: CytMobileFirstRedesignData = {
    isEnabled: value.data?.isEnabled,
    experience: value.data?.experience,
    enableDesktopView: value.data?.enableDesktopView,
    showCardsImage: value.data?.showCardsImage,
    showCardsEyebrow: value.data?.showCardsEyebrow,
    disableAuditWhenVerifiedSelected:
      value.data?.disableAuditWhenVerifiedSelected,
    verifiedPreselected: value.data?.verifiedPreselected,
    discountPercent: value.data?.discountPercent,
    discountCode: value.data?.discountCode,
    discountEndDate: value.data?.discountEndDate,
    discountLabel: value.data?.discountLabel,
    verifiedImageUrl: value.data?.verifiedImageUrl,
    verifiedEyebrow: value.data?.verifiedEyebrow,
    verifiedCtaText: value.data?.verifiedCtaText,
    verifiedBadgeText: value.data?.verifiedBadgeText,
    auditEyebrow: value.data?.auditEyebrow,
    auditCtaText: value.data?.auditCtaText,
    verifiedVisibleBullets: value.data?.verifiedVisibleBullets ?? [],
    verifiedHiddenBullets: value.data?.verifiedHiddenBullets ?? [],
    auditVisibleBullets: value.data?.auditVisibleBullets ?? [],
    auditHiddenBullets: value.data?.auditHiddenBullets ?? [],
    programCard: programCard
      ? {
          enabled: programCard.enabled,
          eyebrow: programCard.eyebrow,
          title: programCard.title,
          description: programCard.description,
          imageUrl: programCard.imageUrl,
          showPrice: programCard.showPrice,
          badgeText: programCard.badgeText,
          ctaText: programCard.ctaText,
          programDiscount: programCard.programDiscount,
          programHiddenBullets: programCard.programHiddenBullets ?? [],
        }
      : undefined,
    currencySelector: value.data?.currencySelector,
    multiCurrency: value.data?.multiCurrency,
  };

  return {
    isLoading: false,
    variant,
    data,
  };
};

export type UseCytMobileFirstRedesignConfigOptions = {
  /** When false, skips Monarch fetch for CYT mobile-first redesign. */
  enabled?: boolean;
};

export const useCytMobileFirstRedesignConfig = (
  options?: UseCytMobileFirstRedesignConfigOptions,
) => {
  const { isLoading, value } = useMonarchRule<{
    data: CytMobileFirstRedesignData;
  }>(CUSTOM_RULE_ID, undefined, { enabled: options?.enabled !== false });

  return {
    isLoading,
    currencySelector: value?.data?.currencySelector,
    multiCurrency: value?.data?.multiCurrency,
  };
};

export default useCytMobileFirstRedesign;
